import { Autocomplete, TextField, Stack, SxProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Controller, Control, FieldError } from 'react-hook-form';
import ErrorFormInput from '../error';

interface AutocompleteFormInputProps {
  parentSx?: SxProps;
  sx?: SxProps;
  required?: boolean;
  control: Control<any>;
  name: string;
  label?: string;
  placeholder?: string;
  error?: FieldError;
  options: AutocompleteFormInputOptionsProps[];
}

export interface AutocompleteFormInputOptionsProps {
  name: string;
  value: string;
}

export default function AutocompleteFormInput({
  parentSx,
  sx,
  required = false,
  control,
  name,
  label,
  placeholder,
  error,
  options
}: AutocompleteFormInputProps) {
  const theme = useTheme();

  return (
    <Stack sx={parentSx}>
      <Controller
        rules={{ required: required }}
        control={control}
        name={name}
        defaultValue={''}
        render={({ field: { onChange, value } }) => (
          <Autocomplete
            size="small"
            value={options.find((option) => option.value === value) || null}
            onChange={(_, newValue) => {
              onChange(newValue ? newValue.value : '');
            }}
            options={options}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                placeholder={placeholder}
                error={!!error}
                size="small"
                inputProps={{
                  ...params.inputProps,
                  sx: { padding: '0.6em 1em' }
                }}
                sx={{
                  backgroundColor: theme.palette.background.default,
                  borderRadius: '4px',
                  minWidth: '12em',
                  ...sx
                }}
              />
            )}
          />
        )}
      />
      {error && <ErrorFormInput error={error} />}
    </Stack>
  );
}
